import dataBloedErnstigLMWH from "../../../../src/data/ernstige-bloedingen-onder-lmwh-ongefractioneerde-heparine.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import SelectBloedLmwhHep from "../../../../src/components/content/SelectBloedLmwhHep";
import * as React from 'react';
export default {
  dataBloedErnstigLMWH,
  BasicCollapse,
  SelectBloedLmwhHep,
  React
};